export const LayoutMixin = (Base) =>
  class extends Base {
    setAlternateLayout({ params: { target } }) {
      this.setFormFieldValue('IdmlSectionPrefix', target)
    }
  };
